<!-- eslint-disable max-len -->
<template>
  <svg
    width="117"
    height="42"
    viewBox="0 0 117 42"
    fill="#6e6e72"
    style="align-self: flex-start"
    class="icons-svg"
  >
    <g clip-path="url(#zenvia_svg__clip0)" fill="#6e6e72">
      <path
        d="M106.609 17.524h-6.462v8.329h6.462v-8.33zM98.778 9.699h-8.33v6.461h8.33V9.7zM106.609 9.699h-6.462v6.461h6.462V9.7zM116.308 7.825h-6.462v8.329h6.462V7.825zM108.476 0h-8.329v6.462h8.329V0zM116.308 0h-6.462v6.462h6.462V0zM42.13 22.615c4.639 0 6.661 1.9 7.591 3.47 1.047 1.667 1.364 3.8 1.383 5.816V42h-5.298v-7.967c0-1.719 0-3.922-.485-5.28-.484-1.356-1.467-2.345-3.877-2.345h-2.287V42h-5.299V22.615h8.271zM76.524 21v-4.846h-5.28v3.534a1.292 1.292 0 001.293 1.293l3.987.019zM76.524 42V23.946a1.292 1.292 0 00-1.292-1.33h-3.968V42h5.26zM60.68 34.401l3.755-10.532a2.016 2.016 0 011.763-1.254h3.735L62.561 42h-3.974l-7.819-19.385h4.4a2.009 2.009 0 011.758 1.247l3.754 10.54zM30.091 24.812c-1.815-2.371-5.169-2.5-7.327-2.287a7.315 7.315 0 00-5.615 3.23c-1.254 1.94-1.615 4.524-1.512 6.953a10.3 10.3 0 002.126 6.462C19.385 41.192 21.93 42 25.58 42h5.376l-.355-2.81a1.202 1.202 0 00-1.15-1.028h-3.128c-3.58 0-5.246-1.35-5.298-4.194h10.875c0-4.083 0-6.784-1.81-9.156zm-9.097 5.816a6.507 6.507 0 01.8-3.393 2.585 2.585 0 014.601.252c.447.988.684 2.057.698 3.14h-6.1z"
      ></path>
      <path
        d="M14.674 26.492c1.467-2.132.705-3.877-1.693-3.877H.381l.35 2.766a1.202 1.202 0 001.15 1.027h6.616a1.802 1.802 0 01-.394.963c-.162.265-7.36 10.752-7.36 10.752C-.717 40.255.045 42 2.436 42h13.11l-.355-2.81a1.202 1.202 0 00-1.15-1.028H6.933c.036-.354.173-.69.394-.97l7.347-10.7zM91.515 24.618a7.348 7.348 0 00-5.467-2.003h-5.64l.361 2.753a1.215 1.215 0 001.157 1.034h4.013a2.662 2.662 0 012.39 1.292c.378.806.538 1.697.466 2.585-1.364-.097-2.727-.058-4.084 0-1.693.097-3.554.368-4.866 1.744-1.311 1.377-1.492 3.431-1.292 5.273a4.666 4.666 0 001.977 3.547c1.629 1.028 3.677 1.138 5.331 1.138h7.831V30.369a7.856 7.856 0 00-2.177-5.77v.02zm-2.695 13.55h-2.584c-1.293 0-2.184-.239-2.585-1.098a4.155 4.155 0 01-.032-2.456 1.938 1.938 0 011.841-1.176c1.06-.058 3.341-.038 3.341-.038l.02 4.768z"
      ></path>
    </g>
    <defs>
      <clipPath id="zenvia_svg__clip0">
        <path fill="#6e6e72" d="M0 0h116.308v42H0z"></path>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Zenvia',
};
</script>
